export default {
  POST_LOGIN_REQUEST: "POST_LOGIN_REQUEST",
  POST_LOGIN_RESPONSE: "POST_LOGIN_RESPONSE",
  POST_LOGIN_RESPONSE_CLEAR: "POST_LOGIN_RESPONSE_CLEAR",
  GET_AMC_REMINDERS_REQUEST: "GET_AMC_REMINDERS_REQUEST",
  GET_AMC_REMINDERS_RESPONSE: "GET_AMC_REMINDERS_RESPONSE",
  GET_AMC_REMINDERS_RESPONSE_CLEAR: "GET_AMC_REMINDERS_RESPONSE_CLEAR",
};
